import { useState, useEffect } from 'react';
import { FormControl, Chip, TextField, IconButton, Divider, AppBar, Tooltip, Toolbar, Grid, CssBaseline, Menu, ListItemText, MenuItem, Box, Stack, Button, Typography, useTheme, alpha, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ListItemIcon } from '@mui/material';

// date time pickers
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import dayjs from 'dayjs';

// config
import GlobalConfig from '../../../components/GlobalConfig'; // Import your global configuration
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import { callApi } from '../../../utils/apiClient';
import { tokens } from '../../../theme/theme';


// icons
import ImportExportIcon from '@mui/icons-material/ImportExport';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';

import CancelIcon1 from '@mui/icons-material/Cancel';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import Amendicon from '@mui/icons-material/AutorenewOutlined';
import AddIcon from "@mui/icons-material/Add";

// hooks
import { useFetchSalesOrders } from '../../../hooks/useSalesOrderEntryList';
import ResponsiveBox from '../../../components/form/ResponsiveScrollBox';
import CustomTableContainer from '../../../components/table/CustomTableContainer';
import SkeletonTableLoader from '../../../components/table/SkeletonTableLoader';
import TableFilterRow from '../../../components/table/TableFilterRow';
import CustomPagination from '../../../components/table/CustomPagination';
import SalesOrderReport from '../../../features/ordermanagement/reports/SalesOrderReport';

import '../../../css/indesCss.css'; // Import your CSS file
import CustomSnackbar from '../../../components/CustomSnackbar';
import AddNewOrder from './AddNewOrder';
import { useTableRecordsPerPage } from '../../../Layout/useTableRecordsPerPage';
import ModuleHelpDialog from '../../../components/ModuleHelpDialog';
import { ordermanagementhelp } from '../../../data/ordermanagementhelp';


const OrderList = ({ handleBackWinderMachineEntry }) => {



    const [FromMODate, setSelectedDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day'));
    const [ToMODate, setSelectedDate1] = useState(dayjs().add(1, 'day'));

    const [FinancierYear, setTopping] = useState(1)


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // const [loading, setLoading] = useState(false);
    // const [tableData, setTableData] = useState([]);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');

    const [editPartyID, setEditPartyID] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState('All');

    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Order');
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);




    const [CompanyID, setCompanyID] = useState(0)

    const recordsPerPage = useTableRecordsPerPage(200,43);
    const [currentPage, setCurrentPage] = useState(1);
    const [orderData, setOrderData] = useState([]);
    const [viewSummary, setViewSummary] = useState(true);

    const [viewReport, setViewReport] = useState(false);
    const [viewOrder, setViewOrder] = useState(true);
    const [DocumentSeries, setDocSequenceid] = useState(11);

const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);



    const [totals, setTotals] = useState({
        totalQtyKg: 0,
        grossWeight: 0,
        grossAmount: 0,
        discountAmount: 0,
        taxableAmount: 0,
        totalAmount: 0,
        insuranceRatePct: 0,
        insuranceAmount: 0,
        freightAmountPerMT: 0,
        freightAmount: 0,
        serviceChargePct: 0,
        sChargeAmount: 0,
        cessAmount: 0,
        taxAmount: 0,
        roundOff: 0,
        netAmount: 0,
        igstpct: 0,
        igstamount: 0,
        cgstpct: 0,
        cgstamount: 0,
        sgstpct: 0,

    });

    useEffect(() => {
        const retrievedUserID = localStorage.getItem('userID');
        if (retrievedUserID) {
            setCompanyID(localStorage.getItem('companyid'));
        }
    }, []); // Empty dependency array to run only once on mount

    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const showSnackbar = () => {
        setSnackbarOpen(true);
    };

    const handleDateChange2 = (date) => {
        setSelectedDate(dayjs(date));
        handleSearch();
    };

    const handleDateChange1 = (date) => {
        setSelectedDate1(dayjs(date));
        handleSearch();
    };

    useEffect(() => {
        handleSearch();
    }, []);

    const handleOpenpage = () => {
        setIndentId(0);
        setConfirmationID(0);
        setViewSummary(false);
    };

    const [indentId, setIndentId] = useState(0);
    const [confirmationId, setConfirmationID] = useState(0);


    const { tableData, loading, fetchOrders } = useFetchSalesOrders();

    const handleSearch = () => {
        fetchOrders({
            FromMODate,
            ToMODate,
            FinancierYear,
            showError,
        });
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        if (FromMODate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToMODate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            handleSearch();
        }
    };





    const getStatusProperties = (status) => {
        let label, color, icon, borderColor;

        switch (status) {
            case 'New':
                label = 'New';
                color = '#33691e';
                icon = <ScheduleIcon />;
                borderColor = '#1976d2';
                break;
            case 'Processed':
                label = 'Processed';
                color = '#689f38';
                icon = <PublishedWithChangesIcon />;
                borderColor = '#388e3c';
                break;
            case 'UnderAmendment':
                label = 'Under Amendment';
                color = '#455a64';
                icon = <Amendicon />;
                borderColor = '#f57c00';
                break;
            case 'Cancelled':
                label = 'Cancelled';
                color = '#ff7043';
                icon = <CancelIcon1 />;
                borderColor = '#d32f2f';
                break;
            case 'Approved':
                label = 'Approved';
                color = '#009688';
                icon = <CheckCircleOutlineIcon />;
                borderColor = '#689f38';
                break;
            default:
                label = 'Unknown';
                color = '#9e9e9e'; // Grey color
                icon = null;
                borderColor = '#757575';
        }

        return { label, color, icon, borderColor };
    };

    const StatusCell = ({ value }) => {
        const { label, color, icon, borderColor } = getStatusProperties(value);
        return (
            <Chip
                label={label}
                size='small'
                fontSize='small'
                style={{ backgroundColor: color, color: '#fff', height: '80%', borderColor: borderColor }}
                icon={icon}
            />
        );
    };


    const [filters, setFilters] = useState({
        cono: '',
        codate_str: '',
        status: '',
        billtocustomer: '',
        billtocity: '',
        billtostate: '',
        shiptocustomer: '',
        shiptocity: '',
        shiptostate: '',
        variety: '',
        bf: '',
        gsm: '',
        width: '',
        length: '',
        unit: '',
        orderqty: '',
    });


    const filteredData = (tableData || []).filter((row) => {
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true;
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });





    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };
    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'New') {
            setSelectedStatus('New');
        }
        else if (option === 'Approved') {
            setSelectedStatus('Approved');
        }
        else if (option === 'Cancelled') {
            setSelectedStatus('Cancelled');
        }
        else if (option === 'Under Amendment') {
            setSelectedStatus('Under Amendment');
        }
        else if (option === 'Processed') {
            setSelectedStatus('Processed');
        }
        else if (option === 'All Order') {
            setSelectedStatus('All');
        }


        setAnchorElFirst(null);
    };



    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };


    const handleCallEdit = (value) => {
        setEditPartyID(value);
        setVendorHome(false);
        setNewVendor(true);

        setIndentId(value.indentid);
        setConfirmationID(value.confirmationorderid);
        setViewSummary(false);
    };




    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const safeFilteredData = filteredData || [];
    const safeTableData = tableData || [];

    const pageCount = Math.ceil(safeFilteredData.length / recordsPerPage);

    const uniqueValues = {
        cono: [...new Set(safeTableData.map(row => row.cono))],
        status: [...new Set(safeTableData.map(row => row.status))],
        billtocustomer: [...new Set(safeTableData.map(row => row.billtocustomer))],

        billtocity: [...new Set(safeTableData.map(row => row.billtocity))],
        billtostate: [...new Set(safeTableData.map(row => row.billtostate))],
        shiptocustomer: [...new Set(safeTableData.map(row => row.shiptocustomer))],
        shiptocity: [...new Set(safeTableData.map(row => row.shiptocity))],
        shiptostate: [...new Set(safeTableData.map(row => row.shiptostate))],
        variety: [...new Set(safeTableData.map(row => row.variety))],
        gsm: [...new Set(safeTableData.map(row => row.gsm))],
        unit: [...new Set(safeTableData.map(row => row.unit))],
    };

    // Get the records for the current page
    const currentRecords = safeFilteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );


    const filterColumns = ['cono', 'codate_str', 'status', 'billtocustomer', 'billtocity', 'billtostate', 'shiptocustomer', 'shiptocity', 'shiptostate', 'variety', 'bf', 'gsm', 'width', 'length', 'unit', 'orderqty',];

    const autoCompleteColumns = ['cono', 'status', 'billtocustomer', 'billtocity', 'billtostate', 'shiptocustomer', 'shiptocity', 'shiptostate', 'variety', 'gsm', 'unit',];

    const handlecallback = async () => {
        setViewSummary(true);
        handleSearch();

    }

    const loadOrderDetails = async (row) => {

        try {
            const orderData = {
                SOrderId: row.indentid,
                SConfirmationId_API: row.confirmationorderid,
            };

            const requestBody = {
                orderData,
                DocumentSeries,
                filter: {
                    FinancierYear,
                    CompanyID: localStorage.getItem("companyid"),
                },
            };

            const response = await fetch(API_ENDPOINTS.loadConfirmationOrderDetail, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                throw new Error("Unable to get order details.!");
            }

            const data = await response.json();


            const dbData = data[0].SSalesOrderSummary[0];


            setTotals({
                totalQtyKg: dbData.total_qty_kg,
                grossWeight: dbData.gross_weight,
                grossAmount: dbData.gross_amount,
                discountAmount: dbData.discount_amount,
                taxableAmount: dbData.taxable_amount,
                totalAmount: dbData.total_amount,
                insuranceRatePct: dbData.insurance_rate_pct,
                insuranceAmount: dbData.insurance_amount,
                freightAmountPerMT: dbData.freight_amount_per_mt,
                freightAmount: dbData.freight_amount,
                serviceChargePct: dbData.service_charge_pct,
                sChargeAmount: dbData.scharge_amount,
                cessAmount: dbData.cess_amount,
                taxAmount: dbData.tax_amount,
                roundOff: dbData.round_off,
                netAmount: dbData.net_amount,
            });



        } catch (error) {
            showError("Unable to get the order details properly.!", "error");
        }

    };

    const handleGenerateOrderReport = async (row) => {
        try {
            let valOrderID = 0;
            let valConfirmationID = 0;

            valOrderID = row.indentid;
            valConfirmationID = row.confirmationorderid;

            if (valConfirmationID > 0) {
                const requestBody = {
                    SConfirmationId_API: valConfirmationID,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: CompanyID,
                    },
                };

                // Await the API call
                const data = await callApi(
                    API_ENDPOINTS.GenerateDataForOrderReport,
                    'POST',
                    { 'Content-Type': 'application/json' },
                    requestBody
                );

                if (data) {
                    console.log("Report data:", data);
                    setOrderData(data);
                    return data; // return if caller needs it
                }
            }
        } catch (error) {
            alert(error.message);
            throw error; // rethrow if caller wants to handle
        }
    };


    const handleViewReport = async (row) => {
        await handleGenerateOrderReport(row);
        await loadOrderDetails(row);

        setViewReport(true);
        setViewOrder(false);
    }

    const handlebackToadd = () => {
        setViewOrder(true);
        setViewReport(false);
    }



    return (
        <Box >


            <CssBaseline />
            {viewSummary && (


                <>

                    {viewOrder && (
                        <>
                            <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                                <Toolbar>
                                    {/* First Menu */}
                                    <Button
                                        color="secondary"
                                        onClick={handleMenuClickFirst}
                                        endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                        sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                    >
                                        {selectedOptionFirst}
                                    </Button>
                                    <Menu
                                        anchorEl={anchorElFirst}
                                        open={openFirst}
                                        onClose={handleMenuCloseFirst}
                                    >
                                        <MenuItem onClick={() => handleMenuItemClickFirst('All Order')}>All Order</MenuItem>
                                        <MenuItem onClick={() => handleMenuItemClickFirst('New')}>New</MenuItem>
                                        <MenuItem onClick={() => handleMenuItemClickFirst('Approved')}>Approved</MenuItem>
                                        <MenuItem onClick={() => handleMenuItemClickFirst('Cancelled')}>Cancelled</MenuItem>
                                        <MenuItem onClick={() => handleMenuItemClickFirst('Under Amendment')}>Under Amendment</MenuItem>
                                        <MenuItem onClick={() => handleMenuItemClickFirst('Processed')}>Processed</MenuItem>

                                    </Menu>

                                    {/* Adding margin-left: auto to push the button to the right */}
                                    <Button size="small" variant="contained" onClick={handleOpenpage} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                                    {/* Second Menu */}
                                    <IconButton
                                        size="small"
                                        aria-label="menu"
                                        sx={{ ml: 2 }}
                                        onClick={handleMenuClickSecond}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>

                                    <Menu
                                        anchorEl={anchorElSecond}
                                        open={openSecond}
                                        onClose={handleMenuCloseSecond}
                                    >
                                        <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                            <ListItemIcon>
                                                <ImportExportIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Import Items" />
                                        </MenuItem>
                                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                            <ListItemIcon>
                                                <FileDownloadIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Export Items" />
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                            <ListItemIcon>
                                                <ViewColumnIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Export Current View" />
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                            <ListItemIcon>
                                                <ListAltIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Preference " />
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                            <ListItemIcon>
                                                <RefreshIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Refresh List" />
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                            {/* <ListItemIcon>
                                    <FormatAlignJustifyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reset Column Width" /> */}
                                            <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                                Reset Columns Width
                                            </Button>
                                        </MenuItem>
                                    </Menu>

                                    <IconButton
                                        size="small"
                                        // edge="start"
                                        // color="inherit"
                                        aria-label="menu"
                                        sx={{ mr: 1, ml: 1 }}
                                        onClick={handleHelpMenuClick}
                                    >
                                        <HelpIcon />
                                    </IconButton>
                                     <ModuleHelpDialog
                                                                              open={helpOpen}
                                                                              onClose={handleCloseHelp}
                                                                              data={ordermanagementhelp.OrderManagementSystem}
                                                                          />

                                    <div>
                                        <IconButton  >
                                            {/* onClick={handleBackDashboard} */}
                                            <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackWinderMachineEntry} />
                                        </IconButton>
                                    </div>
                                </Toolbar>
                            </AppBar>

                            <Stack>
                                <CustomSnackbar
                                    open={snackbarOpen}
                                    message={alertMessage}
                                    onClose={handleSnackbarClose}
                                    type={alertsevierity}
                                />
                            </Stack>

                            <form onSubmit={handleSubmit}>

                                <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0.5, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                                    {/* <Grid item xs={12} sm={12} md={1} lg={4} xl={2.8} mt="5px" display="flex-start" justifyContent="center">
                                             <Button>
                                              View MA Wise Balance Plan Qty
                                              </Button>                                         
                                          </Grid> */}


                                    <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                                        <FormControl fullWidth size="small">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    style={{ marginLeft: '10px' }}
                                                    id="FromMODate"
                                                    value={dayjs(FromMODate)}
                                                    onChange={(date) => handleDateChange2(date)}

                                                    slotProps={{
                                                        textField: {
                                                            size: 'small',
                                                            variant: 'standard', // Removes the filled/outlined border
                                                            InputProps: {
                                                                disableUnderline: true, // Remove underline from 'standard' variant
                                                            },
                                                            sx: {
                                                                backgroundColor: 'transparent',
                                                                padding: 0,
                                                                '& .MuiInputBase-root': {
                                                                    border: 'none',
                                                                    paddingRight: '6px',
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: '18px', // 👈 smaller icon size
                                                                },

                                                            },
                                                        }
                                                    }}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    autoFocus
                                                    format="DD-MMM-YYYY"
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item mt="5px" ml="10px" mr="10px">
                                        <Typography fontWeight="bold">-</Typography>
                                    </Grid>


                                    <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                                        <FormControl fullWidth size="small" >
                                            <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                <DatePicker
                                                    id="ToMODate"
                                                    value={dayjs(ToMODate)}
                                                    format="DD-MMM-YYYY"
                                                    onChange={(date) => handleDateChange1(date)}
                                                    // slotProps={{ textField: { size: 'small', } }}
                                                    slotProps={{
                                                        textField: {
                                                            size: 'small',
                                                            variant: 'standard', // Removes the filled/outlined border
                                                            InputProps: {
                                                                disableUnderline: true, // Remove underline from 'standard' variant
                                                            },
                                                            sx: {
                                                                backgroundColor: 'transparent',
                                                                padding: 0,
                                                                '& .MuiInputBase-root': {
                                                                    border: 'none',
                                                                    paddingRight: '6px', // optional: reduce padding around icon
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: '18px', // 👈 smaller icon size
                                                                },

                                                            },
                                                        }
                                                    }}
                                                    renderInput={(props) => <TextField {...props} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>


                                </Grid>

                                <Divider />


                                <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                                    <CustomTableContainer colors={colors}>
                                        <TableContainer >
                                            {loading ? (
                                                <SkeletonTableLoader rows={5} columns={11} />
                                            ) : (
                                                <Table size="small">
                                                    <TableHead sx={{ height: 10 }}>
                                                        <TableRow>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>CO. NO.</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>CO. DATE</TableCell>
                                                            <TableCell >STATUS</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>BILL TO PARTY</TableCell>
                                                            <TableCell>BILL TO CITY</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>BILL TO STATE</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>SHIP TO PARTY</TableCell>
                                                            <TableCell>SHIP TO CITY</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>SHIP TO STATE</TableCell>
                                                            <TableCell>VARIETY</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 50, whiteSpace: "nowrap" }}>BF</TableCell>
                                                            <TableCell>GSM</TableCell>
                                                            <TableCell sx={{}}>WIDTH</TableCell>
                                                            <TableCell sx={{}}>LENGTH</TableCell>
                                                            <TableCell>UNIT</TableCell>
                                                            <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>ORDER QTY</TableCell>
                                                            {/* <TableCell>Report</TableCell> */}

                                                        </TableRow>

                                                        <TableFilterRow
                                                            columns={filterColumns}
                                                            filters={filters}
                                                            handleFilterChange={handleFilterChange}
                                                            uniqueValues={uniqueValues}
                                                            autoCompleteColumns={autoCompleteColumns}
                                                        />
                                                    </TableHead>
                                                    <TableBody>
                                                        {(currentRecords || []).map((row, index) => (
                                                            <TableRow key={row.IndentId} sx={{
                                                                backgroundColor:
                                                                    index % 2 === 0
                                                                        ? theme.palette.background.default
                                                                        : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                                            }}>
                                                                <TableCell >
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', marginRight:'5px', cursor: 'pointer' }}
                                                                        onClick={() => handleCallEdit(row)}
                                                                    >
                                                                        {row.cono} 
                                                                    </span>

                                                                   

                                                                </TableCell>

                                                                <TableCell>
                                                                    {row.codate_str}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {/* <StatusCell value={row.status} /> */}
                                                                    {row.status}
                                                                </TableCell>
                                                                <TableCell
                                                                    
                                                                >
                                                                    {row.billtocustomer}
                                                                </TableCell>

                                                                <TableCell >{row.billtocity}</TableCell>
                                                                <TableCell>{row.billtostate}</TableCell>
                                                                <TableCell >{row.shiptocustomer}</TableCell>
                                                                <TableCell>{row.shiptocity}</TableCell>
                                                                <TableCell >{row.shiptostate}</TableCell>
                                                                <TableCell >{row.variety}</TableCell>
                                                                <TableCell>{row.bf}</TableCell>
                                                                <TableCell align="right">{row.gsm}</TableCell>
                                                                <TableCell align="right">{row.width}</TableCell>
                                                                <TableCell align="right">{row.length}</TableCell>
                                                                <TableCell>{row.unit}</TableCell>
                                                                <TableCell align="right">{row.orderqty}</TableCell>
                                                                <TableCell>
                                                                    <Tooltip title="Generate Sales Order Report">
                                                                        <IconButton
                                                                            color="secondary"
                                                                            size="small"
                                                                            onClick={() => handleViewReport(row)}
                                                                        >
                                                                            {/* Pick the icon you like */}
                                                                            <SummarizeOutlinedIcon fontSize='small' />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            )}
                                        </TableContainer>
                                    </CustomTableContainer>

                                </ResponsiveBox>
                                <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
                            </form>
                        </>
                    )}


                    {viewReport && (
                        <SalesOrderReport orderData={orderData} handleBackToSalesOrderDetails={handlebackToadd} totals={totals} />
                        // <COMANAGEMENT handleBackWinderMachineEntry={handlebackToadd} />
                    )}

                </>


            ) || (<>
                <AddNewOrder IndentId={indentId} ConfirmationOrderId={confirmationId} handlecallback={handlecallback} />
            </>)}







        </Box>
    );
};

export default OrderList;
